import React from 'react';
import { ItemValue } from 'survey-core/survey.core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { List, Paper, Typography, Grid } from '@material-ui/core';
import CheckTwoTone from '@material-ui/icons/CheckTwoTone';
import CloseIcon from '@material-ui/icons/Close';
import { getTierName, mapFeatures } from '../helpers/customFunctions';

type Props = {
  choices: ItemValue[];
  strings: string[];
  getIcon: (text: string) => string;
};

const useStyles = makeStyles(theme =>
  createStyles({
    wrapper: {
      margin: theme.spacing(3, 0)
    },
    paper: {
      width: '127px',
      height: '173px',
      flexDirection: 'column',
      margin: theme.spacing(1),
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      background: 'var(--light-gray-paper)',
      border: '1px solid var(--on-surface-outline-000000-12-)'
    },
    title: {
      width: '100%',
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(1),
      color: 'var(--black)'
    },
    featureList: {
      textAlign: 'end',
      marginRight: theme.spacing(1),
      color: 'var(--black)'
    },
    feature: {
      lineHeight: 'inherit'
    },
    tickBox: {
      display: 'flex',
      flexDirection: 'column',
      height: '100px'
    },
    logo: {
      width: '24px',
      marginRight: theme.spacing(1)
    },
    iconText: {
      width: '16px'
    }
  })
);

export const SubscriptionUK: React.FC<Props> = ({ choices, strings, getIcon }) => {
  const renderIcons = (feature: string, text: string) => {
    if (mapFeatures(feature, text)) {
      return <CheckTwoTone key={feature} style={{ color: 'var(--green)' }} classes={{ root: classes.iconText }} />;
    } else {
      return <CloseIcon key={feature} style={{ color: 'var(--status-error)' }} classes={{ root: classes.iconText }} />;
    }
  };
  const classes = useStyles();
  return (
    <Grid container justify={'center'} alignItems={'flex-end'} className={classes.wrapper}>
      <List className={classes.featureList}>
        {strings.map((feature: string) => (
          <Typography key={feature} variant="subtitle2" gutterBottom classes={{ root: classes.feature }}>
            {feature}
          </Typography>
        ))}
      </List>
      {choices.map(({ text, value }: ItemValue) => (
        <Paper elevation={0} className={classes.paper} key={value}>
          <div className={classes.title}>
            <div className={classes.logo}>
              <img alt={text} src={`${process.env.PUBLIC_URL}${getIcon(text)}`} />
            </div>
            <Typography variant="body1">{getTierName(text)}</Typography>
          </div>
          <div className={classes.tickBox}>{strings.map((feature: string) => renderIcons(feature, text))}</div>
        </Paper>
      ))}
    </Grid>
  );
};
